import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://ktftzcifwiibhxlmlrwy.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imt0ZnR6Y2lmd2lpYmh4bG1scnd5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzcyMTgzMDQsImV4cCI6MjA5Mjc5NDMwNH0.H2pVTQzZI6Z6d4iB6HAlCJOcwYcVaTb6CZCQNPfzDyY';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
export { supabaseUrl };